import React from 'react';
import PropTypes from 'prop-types';

export const PixelRadLogo = () => (
  <svg width="128px" height="16px" viewBox="0 0 181 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.7011 13.5428V16.7608H18.8471V3.15314H30.5868V6.35325H22.7794V8.22118H29.9868V11.4999H22.7794V13.5428H30.7011Z"
      fill="black"
    />
    <path
      d="M51.5947 3.15314V16.7608H47.7017V9.47479L44.9051 16.7608H40.5693L37.7727 9.47479V16.7608H33.8798V3.15314H39.1442L42.7479 12.3463L46.3516 3.15314H51.5947Z"
      fill="black"
    />
    <path
      d="M61.6164 6.35325H58.8413V9.39979H61.6557C62.8879 9.39979 63.4094 9.01406 63.4094 7.87831C63.4094 6.74255 62.8486 6.35682 61.6164 6.35682V6.35325ZM61.5379 12.6178H58.8378V16.7608H54.9055V3.15314H61.5557C65.3344 3.15314 67.4166 4.81034 67.4166 7.87474C67.4166 10.9391 65.3166 12.6178 61.5379 12.6178Z"
      fill="black"
    />
    <path
      d="M69.981 3.15314H73.9133V10.9391C73.9133 11.6892 74.1454 12.3463 74.5883 12.9249C75.0312 13.5035 75.8026 13.7928 76.8634 13.7928C77.9242 13.7928 78.7135 13.5035 79.1563 12.9249C79.5992 12.3463 79.8314 11.6927 79.8314 10.9391V3.15314H83.7636V10.6498C83.7636 12.8463 83.1279 14.4678 81.8564 15.5072C80.6028 16.5465 78.9278 17.0679 76.8634 17.0679C74.799 17.0679 73.124 16.5465 71.8704 15.5072C70.6167 14.4678 69.981 12.8463 69.981 10.6498V3.15314Z"
      fill="black"
    />
    <path
      d="M87.2888 12.6749C87.8852 12.9642 88.6174 13.2356 89.5067 13.4642C90.4139 13.6749 91.2603 13.7928 92.0711 13.7928C93.6318 13.7928 94.4033 13.5428 94.4033 13.0428C94.4033 12.482 93.5747 12.2142 92.0496 11.907C91.8389 11.8892 91.6068 11.8284 91.3175 11.7534C88.1174 11.0213 86.3244 10.1355 86.2673 7.164C86.2673 5.71752 86.8459 4.63891 88.0209 3.92459C89.196 3.21028 90.721 2.84599 92.5889 2.84599C94.4569 2.84599 96.7141 3.32814 98.2749 4.15675L97.0212 7.02828C95.614 6.46754 93.8033 6.14253 92.4925 6.14253C91.046 6.14253 90.2389 6.44968 90.2389 6.99256C90.2389 7.53544 91.0103 7.78188 92.4175 8.03188L92.9782 8.14617C94.6926 8.51404 96.0248 9.01406 96.9677 9.68909C97.9106 10.3463 98.3927 11.3284 98.3927 12.6392C98.3927 14.125 97.7963 15.2429 96.5998 15.975C95.4069 16.7072 93.8426 17.0751 91.9175 17.0751C90.8782 17.0751 89.8174 16.9393 88.7352 16.65C87.6566 16.3608 86.7316 15.9929 85.978 15.5322L87.2888 12.6785V12.6749Z"
      fill="black"
    />
    <path d="M0 6.33182H1.73935V3.15314H0V6.33182Z" fill="black" />
    <path d="M2.66438 6.33182H5.84306V3.15314H2.66438V6.33182Z" fill="black" />
    <path d="M7.15739 16.7608H11.0897V6.33182H13.3433V3.15314H7.15739V16.7608Z" fill="black" />
    <path d="M14.2684 3.15314V6.33182H15.5791V3.15314H14.2684Z" fill="black" />
    <path d="M107.558 20H109.082V0H107.558V20Z" fill="black" />
    <path
      d="M124.317 3.14368H118.569V16.7599H120.961V11.919H124.22C127.48 11.919 129.1 10.4532 129.1 7.50241C129.1 4.8216 127.518 3.14368 124.317 3.14368ZM124.297 9.77821H120.961V5.28447H124.278C125.802 5.28447 126.631 5.78592 126.631 7.50241C126.631 9.16104 125.917 9.77821 124.297 9.77821Z"
      fill="black"
    />
    <path d="M133.78 16.7599H136.172V3.14368H133.78V16.7599Z" fill="black" />
    <path
      d="M151.749 16.7599L147.622 9.72035L151.479 3.14368H148.76L146.06 8.11958L143.359 3.14368H140.486L144.343 9.75892L140.254 16.7599H143.07L145.925 11.3983L148.914 16.7599H151.749Z"
      fill="black"
    />
    <path
      d="M165.576 3.14368H155.721V16.7599H165.654V14.6191H158.113V10.8197H164.921V8.67888H158.113V5.28447H165.576V3.14368Z"
      fill="black"
    />
    <path d="M173.096 14.6191V3.14368H170.704V16.7599H180.058V14.6191H173.096Z" fill="black" />
  </svg>
);

PixelRadLogo.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
